const TYPE = 'APPEND_SERIAL_DEVICE';

const action = ({ id, data }) => (dispatch) => dispatch({ type: TYPE, payload: { id, data } });

export default { action, TYPE };
